import { analytics } from '@/utils/analytics';
import { EventProperties } from '@soluto-private/analytics-core';
import { NonSegmentEvents } from './types';

/*
  Function that wraps the track function from the analytics-core package.
  This allows D2C to only specify events from the
  Non-SegmentEvents enum and not allow arbitrary event names as strings.
*/
export const trackD2CNonSegmentAnalytics = async (
  eventName: NonSegmentEvents,
  payload: EventProperties,
) => {
  analytics.track(eventName, payload);
};
